import { ConnectProto } from "@racoon/api";
import { Namespace, useT } from "@racoon/i18n";
import { Hyperlink } from "@racoon/ui";

/** An organisation's name over its БИН, as the order map shows a customer or a provider. */
export const OrganizationLabel = ({
  organization,
  onOpen,
}: {
  organization: ConnectProto.Organization;
  /** Opens the organisation's card; without it the name is plain text. */
  onOpen?: () => void;
}) => {
  const t = useT();
  // The colour is the row's body text: `Hyperlink` inherits it at rest and turns blue on hover.
  return (
    <div className="flex w-full min-w-0 flex-col text-xs leading-4 text-text-body">
      {onOpen ? (
        <Hyperlink className="max-w-full truncate" title={organization.name} onOpen={onOpen}>
          {organization.name}
        </Hyperlink>
      ) : (
        <span className="truncate" title={organization.name}>
          {organization.name}
        </span>
      )}
      {organization.bin && (
        <span className="truncate text-text-subtle">
          {t(Namespace.Orders, "create.customerBin", { bin: organization.bin })}
        </span>
      )}
    </div>
  );
};
